import { combineReducers } from 'redux';
import account from './account/account.slice';
import area from './area/area.slice';
import refresh from './refresh/refresh.slice';
import unread from './unread/unread.slice';

export default combineReducers({
  account,
  refresh,
  area,
  unread,
});
